import { useState } from 'react';
import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Warehouse } from 'lucide-react';
import { toast } from 'sonner';

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username || !password) {
      toast.error('Ingresa usuario y contraseña');
      return;
    }
    setLoading(true);
    try {
      await login(username, password);
      toast.success('Bienvenido al sistema');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F7F9FB] p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex h-14 w-14 rounded-2xl bg-[#0F6E87] items-center justify-center mb-4">
            <Warehouse className="h-7 w-7 text-white" />
          </div>
          <h1 className="text-2xl font-semibold text-[#151A22]">Control de Inventario</h1>
          <p className="text-sm text-muted-foreground mt-1">Acumuladores - Sistema de Bodega</p>
        </div>

        <Card className="border shadow-sm bg-white">
          <CardHeader className="pb-4">
            <CardTitle className="text-lg text-center">Iniciar Sesión</CardTitle>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="text-sm font-medium text-foreground">Usuario</label>
                <Input
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Ingresa tu usuario"
                  className="mt-1"
                  data-testid="login-username-input"
                  autoFocus
                />
              </div>
              <div>
                <label className="text-sm font-medium text-foreground">Contraseña</label>
                <Input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Ingresa tu contraseña"
                  className="mt-1"
                  data-testid="login-password-input"
                />
              </div>
              <Button
                type="submit"
                className="w-full bg-[#0F6E87] hover:bg-[#0C5D73] text-white"
                disabled={loading}
                data-testid="login-submit-button"
              >
                {loading ? 'Ingresando...' : 'Iniciar Sesión'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
